export const artistsData = [
  {
    id: "slum-denizens",
    name: "Slum Denizens",
    slug: "slum-denizens",
    bio: "Slum Denizens is an eclectic electronic project blending humor, nostalgia, and sharp social commentary into a unique sonic identity. Looking ahead, Slum Denizens are steering into darker territory, taking aim at politics and history with tracks critiquing the education system, the military-industrial complex, and big pharma. Their evolving sound fuses influences from reggae, big beat, breakbeat, psytrance, early computer music, and even baroque fugues.",
    image: "/images/artists/slum-denizens-square.png",
    featured: true,
    genres: ["Electronic", "Experimental", "Eurodance", "Funk", "Reggae", "Psytrance"],
    featuredTracks: ["groove-solution", "my-electric-toothbrush"]
  },
  {
    id: "lee-and-the-lips",
    name: "Lee & the Lips",
    slug: "lee-and-the-lips",
    bio: "Centered around guitarist Lee Wilson, Lee &amp; the Lips is a classic rock band drawing inspiration from the legendary sounds of the 60s, 70s and 80s. Lee & the Lips delivers a nostalgic yet fresh take on classic rock, while not afraid to branch out into other genres like jazz, reggae or even classical.",
    image: "/images/artists/lee-and-the-lips.jpg",
    featured: true,
    genres: ["Rock", "Classic Rock", "Classical"],
    featuredTracks: ["track-3", "track-4"]
  }
];